import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import SimpleLayout from "../../../components/Layout/Simple";
import ResetPasswordContent from "../../../components/Pages/Auth/ResetPassword";

const { displayName } = config;

export default function ResetPassword(): React.ReactNode {
  useEffect(() => {
    document.title = `${displayName}: New Password`;
  }, []);

  return (
    <SimpleLayout>
      <ResetPasswordContent />
    </SimpleLayout>
  );
}
